module.exports = __webpack_public_path__ + "static/media/shirtsinbulk.51e4e1b3.svg";